$(document).on("click", ".packages-payment-interval-tab .nav-link", function(event) {
  event.preventDefault()
  let element = $(this)
  if (element.hasClass("active")) { return }

  let paymentInterval = element.data("paymentInterval")
  $(".payment-interval-selection").val(paymentInterval)
  $(".price").addClass("visibility-none");
  $('.price[data-payment-interval="' + paymentInterval + '"]').removeClass("visibility-none");
  $(".packages-payment-interval-tab .nav-link").removeClass("active")
  element.addClass("active")
})

$(document).on("change", "#package_kind", function() {
  if ($(this).val() === "public") {
    $(".default-field").removeClass("d-none")
  } else {
    $(".default-field").addClass("d-none")
    $(".default-field input[type=checkbox]").prop("checked", false)
  }
})

$(document).on("click", ".package-column", function(event) {
  event.preventDefault;
  let parent = $(this).closest("table")
  let id = $(this).data("packageId")
  let active = $(this).hasClass("active")

  if (active) {
    parent.find(".package-column").removeClass("active")
    parent.find(".package-column").removeClass("inactive")
    parent.find(".package-column input.package-id").attr('checked', false)

    let defaultColumns = parent.find(".package-column[data-package-default]")
    if (defaultColumns.length > 0) {
      parent.find(".package-column").addClass("inactive")

      defaultColumns.addClass("active")
      defaultColumns.removeClass("inactive")
      defaultColumns.find("input.package-id").attr('checked', true)
    }
  } else {
    parent.find(".package-column").removeClass("active")
    parent.find(".package-column").addClass("inactive")
    parent.find(".package-column input.package-id").attr('checked', false)
    parent.find(".package-column[data-package-id='" + id + "']").addClass("active")
    parent.find(".package-column[data-package-id='" + id + "']").removeClass("inactive")
    parent.find(".package-column[data-package-id='" + id + "'] input.package-id").attr('checked', true)
  }
})
